
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressScenarioChooserEN]",
      function () {
        return require("private-next-pages/[...wordpressScenarioChooserEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressScenarioChooserEN]"])
      });
    }
  